import { format, setHours, setMinutes } from 'date-fns'
import React from 'react'
import { FiClock } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import { timeFormat } from '../../../utils/DateFormat'
import { Input } from '../elements'
import FormElement from '../FormElement'
import { IFormElementProps } from '../FormElement/FormInput'
import withReduxForm from '../withReduxForm'
import withWrapper from '../withWrapper'
import TimePicker from './TimePicker'
import withCustomFormat from './withCustomFormat'
import withRedux from './withRedux'

const TimeInput = FormElement(
  withWrapper(
    ({
       name,
       isSelected,
       errorMsg,
       onChange,
       readonly,
       value,
       size = 1,
       className,
       disabled,
       formatHours,
       warningMsg,
       required,
       onClick,
       placeholder,
       isSmallReservation,
       disallowZero = false,
       onlyMinutes = false,
     }: IFormElementProps) => {
      const [expand, setExpand] = React.useState(false)
      const anchor = React.useRef()
      const h12 = formatHours.search('hh') !== -1

      function showPicker() {
        setExpand(true)
      }

      function closePicker() {
        setExpand(false)
      }

      function onclick(type) {
        return function(e) {
          showPicker()
          e.name = name
          if (type === 'clock') {
            e.currentTarget.value = value
          }
          if (onClick) {
            onClick(e)
          }
        }
      }

      React.useEffect(() => {
        document.addEventListener('touchmove', function() {
          closePicker()
        })
        return () => {
          document.removeEventListener('touchmove', function() {
            closePicker()
          })
        }
      })

      function formatedDate() {
        if (onlyMinutes) {
          return format(
            setMinutes(0, Number(value.split(':')[1])),
            timeFormat('mm'),
          )
        }

        const formated = format(
          setMinutes(
            setHours(new Date(), Number(value.split(':')[0])),
            Number(value.split(':')[1]),
          ),
          timeFormat(formatHours ? formatHours : 'mm:GG'),
        )

        const onlyHours = formated.split(':')[0] === formated

        return value
          ? h12 && !onlyHours
            ? `${Number(formated.split(':')[0])}:${formated.split(':')[1]}`
            : formated
          : value
      }

      return (
        <React.Fragment>
          <Flex
            justifyEnd={true}
            alignCenter={true}
            style={{ position: 'relative' , backgroundColor: disabled ? '#f5f5f5' : 'transparent'}}
            full={true}
          >
            <Input
              name={name}
              placeholder={placeholder}
              selected={isSelected}
              error={errorMsg as any}
              warning={warningMsg && warningMsg !== ''}
              type={'text'}
              onClick={onclick('input')}
              onChange={onChange}
              required={required}
              value={formatedDate()}
              size={size}
              disabled={disabled}
              className={className}
              autoComplete={'off'}
              readOnly={readonly}
              ref={anchor}
              smallReservation={isSmallReservation}
              data-cy={className}
              style={{
                backgroundColor: 'transparent',
                color: disabled? '#c2c2c2' : 'transparent',
                cursor: 'pointer',
                textShadow: disabled ? 'unset' : '0 0 0 black',
              }}
            />
            <Flex
              onClick={disabled ? undefined : onclick('clock')}
              style={{
                position: 'absolute',
                right: size ? `${10 * size}px` : '10px',
              }}
            >
              <FiClock size={18 * size} />
            </Flex>
          </Flex>
          <TimePicker
            value={setMinutes(
              setHours(new Date(), Number(value.split(':')[0])),
              Number(value.split(':')[1]),
            )}
            onChange={onChange}
            close={closePicker}
            anchor={anchor}
            disabled={disabled}
            expand={expand}
            formatHours={formatHours}
            disallowZero={disallowZero}
            h12={h12}
            onlyMinutes={onlyMinutes}
          />
        </React.Fragment>
      )
    },
  ),
)

export default withReduxForm<IFormElementProps>(
  withCustomFormat(withRedux(TimeInput)),
)
export { TimeInput }
